module.exports = __webpack_public_path__ + "static/img/zp.c00a0c5d.jpg";